import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { withProps } from '../withProps.js';

const IconFeatherChevronDown = withProps(props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.52851 5.52858C3.78886 5.26823 4.21097 5.26823 4.47132 5.52858L7.99992 9.05717L11.5285 5.52858C11.7889 5.26823 12.211 5.26823 12.4713 5.52858C12.7317 5.78892 12.7317 6.21103 12.4713 6.47138L8.47132 10.4714C8.21097 10.7317 7.78886 10.7317 7.52851 10.4714L3.52851 6.47138C3.26816 6.21103 3.26816 5.78892 3.52851 5.52858Z",
  fill: "currentColor"
})));
IconFeatherChevronDown.displayName = 'IconFeatherChevronDown';

export { IconFeatherChevronDown };
